// src/analytics/metaPixel.js
// ✅ Meta Pixel for Piano With Pan
// Mirrors the GA pattern: consent-gated load + safe event helpers.

export const META_PIXEL_ID = "979311498029201";

/**
 * Inject the Meta Pixel base code. Idempotent — safe to call multiple times.
 * Only call AFTER the user has granted analytics consent.
 */
export function ensurePixelLoaded() {
  if (typeof window === "undefined") return;
  if (window.fbq) return; // already loaded

  // Standard Meta Pixel base code, rewritten cleanly
  /* eslint-disable */
  !(function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = "2.0";
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(
    window,
    document,
    "script",
    "https://connect.facebook.net/en_US/fbevents.js"
  );
  /* eslint-enable */

  window.fbq("init", META_PIXEL_ID);
  window.fbq("track", "PageView");
}

/**
 * Disable the pixel for users who reject analytics.
 * Meta Pixel has no clean "off switch", so we stub fbq to a no-op.
 */
export function disablePixel() {
  if (typeof window === "undefined") return;
  window.fbq = function () {};
}

/**
 * Safe event sender — only fires when fbq is loaded (i.e. consent granted).
 * @param {string} eventName - e.g. "Purchase", "Lead", "CompleteRegistration"
 * @param {object} params   - event payload (value, currency, content_ids…)
 */
export function sendPixelEvent(eventName, params = {}) {
  if (typeof window !== "undefined" && typeof window.fbq === "function") {
    window.fbq("track", eventName, params);
    // eslint-disable-next-line no-console
    console.log("📘 Pixel Event:", eventName, params);
  }
}

/** SPA page view — call on every route change. */
export function trackPixelPageView() {
  sendPixelEvent("PageView");
}

// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
// CONVERSION EVENTS — map 1:1 to your GA helpers
// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

/** User landed on the paywall — high-intent signal for "ViewContent" audience. */
export function pixelViewPaywall() {
  sendPixelEvent("ViewContent", {
    content_name: "Paywall",
    content_category: "subscription",
  });
}

/** User clicked a plan's pay button — Meta's standard "InitiateCheckout". */
export function pixelBeginCheckout(planId, amount) {
  sendPixelEvent("InitiateCheckout", {
    value: amount,
    currency: "INR",
    content_ids: [planId],
    content_name: `Piano With Pan ${planId} Pass`,
    content_type: "product",
    num_items: 1,
  });
}

/** Payment confirmed — THE conversion event Ads Manager optimises against. */
export function pixelPurchase(transactionId, amount, planId) {
  sendPixelEvent("Purchase", {
    value: amount,
    currency: "INR",
    content_ids: [planId],
    content_name: `Piano With Pan ${planId} Pass`,
    content_type: "product",
    order_id: transactionId,
  });
}

/** New account / login — Meta calls this "CompleteRegistration". */
export function pixelSignUp(method = "email") {
  sendPixelEvent("CompleteRegistration", {
    registration_method: method,
    status: true,
  });
}

/** Optional: lead capture (e.g. someone submitted email but hasn't paid). */
export function pixelLead(source = "unknown") {
  sendPixelEvent("Lead", { source });
}